import React from 'react';
import DocumentationSidebar from '../component/DocumentationSidebar';
import { DocContentImage, DocSidebarImage } from '../component/DocMedia';
import SettingsMenuOverview from './SettingsMenuOverview';
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';

export default function SecuritySettings() {
  const { t } = useTranslation();
  const image001 = useDocImage('security-settings-img', 'image001.png', 'settings');
  const image002 = useDocImage('security-settings-img', 'image002.png', 'settings');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.securitySettings.title')}</h1>
            <p className="header-para">{t('documentation.securitySettings.intro')}</p>

            <div className="card dashboard-card mb-4">
              <div className="card-header px-3">{t('documentation.securitySettings.accessing.title')}</div>
              <div className="card-body">
                <SettingsMenuOverview />
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.securitySettings.accessing.steps.step1') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.securitySettings.accessing.steps.step2') }} />
                </ul>
                <DocSidebarImage src={image001} alt={t('documentation.securitySettings.accessing.imageAlt')} />
                <ul className="mb-0">
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.securitySettings.accessing.steps.step3') }} />
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header px-3">{t('documentation.securitySettings.options.title')}</div>
              <div className="card-body">
                <DocContentImage src={image002} alt={t('documentation.securitySettings.options.imageAlt')} />
                <ul>
                  <li>{t('documentation.securitySettings.options.items.sso')}</li>
                  <li>{t('documentation.securitySettings.options.items.mfa')}</li>
                  <li>{t('documentation.securitySettings.options.items.lockout')}</li>
                  <li>{t('documentation.securitySettings.options.items.passwordExpiry')}</li>
                  <li>{t('documentation.securitySettings.options.items.save')}</li>
                </ul>
              </div>
            </div>

            <p className="alert alert-info mb-0">{t('documentation.securitySettings.permissionsNote')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
